import { render, staticRenderFns } from "./PNScalePods.vue?vue&type=template&id=2491b3dc&"
import script from "./PNScalePods.vue?vue&type=script&lang=js&"
export * from "./PNScalePods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports